import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { IChat } from "../../../interfaces/chat";
import { sendChatMessage } from "../../../services/chat.service";
import { useError } from "../../../store/ErrorModal";
import { useUser } from "../../../store/UserStore";

export default function useChatInput(props: { uid: string }) {
  const [isSendingMessage, setIsSendingMessage] =
    React.useState<boolean>(false);
  const [isOpenMenu, setIsOpenMenu] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");
  const user = useUser();
  const history = useHistory();
  const pathName = useLocation().pathname.split("/")[1];
  const { onError } = useError();
  const handleSendMessage = async () => {
    if (isSendingMessage) return;
    if (!user.userData) return history.replace("/login");
    if (!message) return;
    if (!props) return;
    const newChat: IChat = {
      uid: props?.uid,
      timestamp: new Date().getTime(),
      text: pathName === "adminChat" ? "[Admin] " + message : message,
      type: "text",
      doctorId: user.userData.uid,
    };
    try {
      setIsSendingMessage(true);
      await sendChatMessage(newChat);
      setIsSendingMessage(false);
    } catch (error) {
      onError(error as any);
      setIsSendingMessage(false);
    }
    setIsSendingMessage(false);
    setMessage("");
  };

  return {
    handleSendMessage,
    message,
    setMessage,
    isSendingMessage,
    setIsOpenMenu,
    user,
    isOpenMenu,
  };
}
